import type { SupportedTrafficSource } from "../../constants";
import { trafficSources } from "../../constants";

type Channel = SupportedTrafficSource;
type DomainData = unknown[] | null;

export const countExcelRows = (data: Partial<Record<Channel, DomainData>>): number =>
    trafficSources.reduce((total, source) => total + (data[source]?.length ?? 0), 0);
